import { render, staticRenderFns } from "./HostingKvmAddons.vue?vue&type=template&id=1706df38&scoped=true&"
import script from "./HostingKvmAddons.vue?vue&type=script&lang=js&"
export * from "./HostingKvmAddons.vue?vue&type=script&lang=js&"
import style0 from "./HostingKvmAddons.vue?vue&type=style&index=0&id=1706df38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1706df38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1706df38')) {
      api.createRecord('1706df38', component.options)
    } else {
      api.reload('1706df38', component.options)
    }
    module.hot.accept("./HostingKvmAddons.vue?vue&type=template&id=1706df38&scoped=true&", function () {
      api.rerender('1706df38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/HostingKvmAddons.vue"
export default component.exports